import Image from "next/image";
import Link from "next/link";
import { usePath } from "../contexts/PathContext";

function Logo() {
  const { isMerchantPage } = usePath();
  return (
    <Link
      href={isMerchantPage ? "/merchant" : "/"}
      onClick={() => window.scrollTo(0, 0)}
    >
      <Image
        src="/assets/logo/parttime_logo.svg"
        width={80}
        height={80}
        alt="派派首頁"
        priority
      />
    </Link>
  );
}

export default Logo;
